export { jobWorkplaceTypesSk } from './sk';
export { jobWorkplaceTypesEn } from './en';
export { jobWorkplaceTypesCz } from './cz';

// Helper function to get job workplace types by language
import { jobWorkplaceTypesSk } from './sk';
import { jobWorkplaceTypesEn } from './en';
import { jobWorkplaceTypesCz } from './cz';

export function getJobWorkplaceTypes(lang: 'sk' | 'en' | 'cz') {
  switch (lang) {
    case 'sk':
      return jobWorkplaceTypesSk;
    case 'en':
      return jobWorkplaceTypesEn;
    case 'cz':
      return jobWorkplaceTypesCz;
    default:
      return jobWorkplaceTypesSk; // fallback to Slovak
  }
}
